import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import ExternalLinkModal from '../../../_shared/components/external-link-modal';
const TourTicketsCta = (props) => {
    const [confirming, setConfirming] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsxs("button", { type: "button", className: props.className, onClick: () => setConfirming(true), children: [props.label, _jsx("i", { className: "bi bi-box-arrow-up-right ms-2", "aria-hidden": "true" })] }), _jsx(ExternalLinkModal, { isOpen: confirming, url: props.url, onClose: () => setConfirming(false), onConfirm: () => {
                    setConfirming(false);
                    window.open(props.url, '_blank', 'noopener,noreferrer');
                } })] }));
};
export default TourTicketsCta;
